import { useCallback, useEffect, useState } from 'react';

const DAUM_POSTCODE_URL = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

export function useDaumPostcode() {
  const [ready, setReady] = useState(Boolean(window.daum?.Postcode));

  useEffect(() => {
    if (window.daum?.Postcode) {
      setReady(true);
      return undefined;
    }

    const existingScript = document.querySelector(`script[src="${DAUM_POSTCODE_URL}"]`);
    if (existingScript) {
      existingScript.addEventListener('load', () => setReady(true));
      return undefined;
    }

    const script = document.createElement('script');
    script.src = DAUM_POSTCODE_URL;
    script.async = true;
    script.onload = () => setReady(true);
    document.body.appendChild(script);

    return undefined;
  }, []);

  const openPostcode = useCallback((onComplete) => {
    if (!window.daum?.Postcode) {
      return false;
    }

    new window.daum.Postcode({
      oncomplete: (data) => {
        const baseAddress = data.userSelectedType === 'R' ? data.roadAddress : data.jibunAddress;
        const building = data.buildingName ? ` ${data.buildingName}` : '';

        onComplete({
          zonecode: data.zonecode,
          address: `(${data.zonecode}) ${baseAddress}${building}`.trim()
        });
      }
    }).open();

    return true;
  }, []);

  return { ready, openPostcode };
}
